import React from 'react';
import { Button } from 'antd';

import './Footer.css';

const ContractSettingsFooter = ({
  disabledFieldsSetter,
  resetDefaultValues,
}) => {
  console.log('disabledFieldsSetter', disabledFieldsSetter);
  return (
    <div className="settingsActions">
      <Button
        type="secondary"
        className="resetDefaultBtn"
        onClick={resetDefaultValues}
      >
        Сбросить по умолчанию
      </Button>

      <Button
        type="primary"
        className="apllyButton"
        onClick={disabledFieldsSetter}
      >
        Редактировать
      </Button>
    </div>
  );
};

export default ContractSettingsFooter;
